import { EPropertyType, IProperty, IPropertyEnums } from "@kuika/kuika-cl-model";
import * as React from "react";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";

export interface IPropertyFormEnumPropertyState {
  propertyValue: string;
}

export interface IPropertyFormEnumPropertyProps {
  property: IProperty;
  applyPropertyValueChanged: (value: any) => void;
}

export class PropertyFormEnumProperty extends React.PureComponent<
  IPropertyFormEnumPropertyProps,
  IPropertyFormEnumPropertyState
> {
  propertyHelper: PropertyHelper;

  constructor(props) {
    super(props);
    this.propertyHelper = new PropertyHelper();
    this.state = {
      propertyValue: this.props.property.symbol.fixedValue
    };
  }

  componentDidUpdate = (prevProps: IPropertyFormEnumPropertyProps) => {
    if (prevProps === this.props) return;
    this.setState({ propertyValue: this.getPropertyValueFromProps() });
  };

  getPropertyValueFromProps = (): string => {
    return this.propertyHelper.getEnumPropertyDefaultValue(this.props.property);
  };

  applyPropertyValueChanged = (value: string) => {
    this.setState({ propertyValue: value });
    if (this.props.applyPropertyValueChanged) {
      this.props.applyPropertyValueChanged(value);
    }
  };

  getEnumPropertyOptions = (): KuikaSelectboxOption[] => {
    const p: IProperty = this.props.property;
    if (p && p.typeOptions && KMainFunctions.isObjectEmpty(p.typeOptions) === false && p.typeOptions.find) {
      const pType = p.typeOptions.find((x) => x.propertyType === EPropertyType.enum.toString());
      if (pType) {
        return (pType.enums ?? []).map((x: IPropertyEnums): KuikaSelectboxOption => ({
          key: `pev_${x.value}`,
          value: x.value,
          label: x.key
        }));
      }
    }
    return [];
  };

  render() {
    return (
      <>
        <div className="kuika_property-grid-column kuika-right-panel__col">
          <KuikaSelectbox
            size="sm"
            value={this.state.propertyValue ?? null}
            className="kuika_input_property"
            placeholder=""
            onChange={(value: string): void => {
              this.applyPropertyValueChanged(value);
            }}
            style={{ marginLeft: "12px", width: "calc(100% - 24px)" }}
            options={this.getEnumPropertyOptions()}
          />
        </div>
      </>
    );
  }
}
